export { GroupSimpleEventAttendancePage } from './GroupSimpleEventAttendancePage';
